import { defineMessages } from 'react-intl';

export default defineMessages({
    Header: {
        id: 'qnb.spt.SgSptAggsPriceChangeModal.Header',
        defaultMessage: 'Your price has been updated'
    },
    DueTo: {
        id: 'qnb.spt.SgSptAggsPriceChangeModal.DueTo',
        defaultMessage: 'Due to the additional details you have provided your price has been updated.'
    },
    NewPrice: {
        id: 'qnb.spt.SgSptAggsPriceChangeModal.NewPrice',
        defaultMessage: 'Your new Premium is:'
    }
});
